/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoFssIcon24Solid = forwardRef('GovKoFssIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 1a1 1 0 1 0-2 0v1.552c-4.777.5-8.5 4.539-8.5 9.448 0 4.909 3.723 8.948 8.5 9.448V23a1 1 0 1 0 2 0v-1.552c4.777-.5 8.5-4.54 8.5-9.448 0-4.909-3.723-8.948-8.5-9.448V1Zm-2 17.084v1.518a7.625 7.625 0 0 1 0-15.104v1.518a6.125 6.125 0 0 0 0 12.068Zm0-3.225v1.566a4.498 4.498 0 0 1 0-8.75v1.566a2.998 2.998 0 0 0 0 5.618Z" })));
});
